export function fileToDataUrl (file) {
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob)) {
      return reject(new TypeError('Invalid argument: expected a File or Blob'))
    }

    const reader = new FileReader()
    reader.onload = () => {
      try {
        const buffer = reader.result
        const bytes = new Uint8Array(buffer)
        let binary = ''
        const chunkSize = 8192
        for (let i = 0; i < bytes.length; i += chunkSize) {
          binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize))
        }
        const base64String = `data:${file.type};base64,${window.btoa(binary)}`
        resolve({ data: buffer, base64String })
      } catch (err) {
        reject(err)
      }
    }
    reader.onerror = error => reject(error)
    reader.readAsArrayBuffer(file)
  })
}
